var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnSysWidget001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 473.658 473.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#EAF5E5",
    cx: 236.829,
    cy: 236.829,
    r: 236.829
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#65A844",
    d: "M263.922,186.034c0-31.3-0.004-62.601-0.007-93.898c0-3.803-3.123-7.064-6.959-7.064 c-31.297,0-62.59,0.004-93.883,0.007c-6.167,0-9.353,7.625-4.985,11.997c12.333,12.333,24.67,24.67,37.007,37.007 c-20.594,20.59-41.188,41.18-61.778,61.774c-12.782,12.782,7.128,32.542,19.94,19.726c20.557-20.557,41.113-41.113,61.666-61.67 c12.356,12.356,24.704,24.704,37.056,37.056c2.345,2.345,5.153,2.476,7.461,1.406C261.925,191.554,263.922,189.444,263.922,186.034 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#65A844",
    d: "M167.59,361.511c0,6.499-5.265,11.765-11.765,11.765h-46.423c-6.492,0-11.765-5.265-11.765-11.765 v-79.855c0-6.499,5.273-11.765,11.765-11.765h46.423c6.499,0,11.765,5.265,11.765,11.765L167.59,361.511L167.59,361.511z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#65A844",
    d: "M264.82,361.511c0,6.499-5.265,11.765-11.765,11.765h-46.423c-6.492,0-11.765-5.265-11.765-11.765 V223.692c0-6.499,5.273-11.765,11.765-11.765h46.423c6.499,0,11.765,5.265,11.765,11.765L264.82,361.511L264.82,361.511z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#65A844",
    d: "M364.54,361.511c0,6.499-5.265,11.765-11.765,11.765h-46.423c-6.492,0-11.765-5.265-11.765-11.765 V165.728c0-6.499,5.273-11.765,11.765-11.765h46.423c6.499,0,11.765,5.265,11.765,11.765L364.54,361.511L364.54,361.511z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnSysWidget001);
export default __webpack_public_path__ + "static/media/sn_sys_widget_001.fbc61a56d41b4f61aebb9e8eb51136b4.svg";
export { ForwardRef as ReactComponent };